export type GovTradesTab = 'Overview' | 'Securities' | 'Members';

export function getActiveGovTradesTab(pathname: string): GovTradesTab | null {
  switch (pathname) {
    case '/government-trades':
      return 'Overview';
    case '/government-trades/securities':
      return 'Securities';
    case '/government-trades/members':
      return 'Members';
    default:
      return null;
  }
}

export const GOV_TRADES_TAB_DESCRIPTIONS: Record<GovTradesTab, string> = {
  Overview:
    'Track stock trades made by US Senators and Representatives in real time. Explore recent transactions, most active lawmakers, and market performance trends—updated daily for transparency',
  Securities:
    "Explore recent trades, largest transactions, top traded securities, and Congress's top picks in our Securities page. Stay updated on the latest financial activities of elected officials, identify trending stocks, and uncover insights into congressional investment strategies.",
  Members:
    "Track US Congress members' stock trades in real time. Search for lawmakers, view the latest trades, volumes, and transparency updates from both the House and Senate.",
};
